const Account = {
	init() {
		$('.js-toggle').on('click', function () {
			$(this).toggleClass('accountOrder-row--selected');
		});
	},
};

export default Account;
